import { createClient } from '@supabase/supabase-js';

import type { Database } from './types';

const url = import.meta.env.VITE_SUPABASE_URL;
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

/**
 * ⚠️ Esta guarda é a **segunda** linha de defesa, e chegar aqui já é tarde: com
 * as variáveis ausentes, quem vê o erro é a pessoa que abriu o app, não quem
 * publicou. Quem barra a tempo é `assertBuildEnv` no `vite.config.ts`, que
 * derruba o `pnpm build`.
 *
 * Ela fica porque cobre o que o build não vê: um `.env` com a chave presente e
 * **vazia**, e o `pnpm dev` (onde não há build para falhar).
 */
if (!url || !publishableKey) {
  throw new Error(
    'VITE_SUPABASE_URL e VITE_SUPABASE_PUBLISHABLE_KEY são obrigatórias e chegaram vazias. ' +
      'Local: copie .env.sample para .env e preencha. Publicação: elas precisam existir no ' +
      'ambiente de build do Cloudflare — ver docs/11-deploy-cloudflare.md §6.',
  );
}

/**
 * Instância única do client. Só `services/` pode importar — a fronteira é o que
 * mantém a base portável. Ver docs/apendice-supabase.md.
 */
export const supabase = createClient<Database>(url, publishableKey);
